<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <import-navigator currentStep="dimensions"></import-navigator>
                <div class="wrap-text">
                    <b>
                        Complexity management
                    </b>
                    <span>
                        Take complexity down to a manageable level
                    </span>
                </div>
            </div>
        </div>
        <div [ngClass]="{ 'loading':loading, 'middle-part':true, 'set-up':true }">
            <div class="current-status">
                <div class="left">
                    <div class="dot green"></div>
                    <div class="dot"></div>
                </div>
                <div class="divider"></div>
                <div class="right">
                    <div class="wrap">
                        Current data complexity is {{roundedMultiplierDesc}} what the tool can comfortably handle:
                    </div>
                    <div class="wrap">
                        <div class="bar">
                            <div class="bar-line">
                                <div class="bar-segment green" [style.width]="greenPerc + '%'"></div>
                                <div class="bar-segment orange" [style.width]="yellowPerc + '%'"></div>
                                <div class="bar-segment red" [style.width]="redPerc + '%'"></div>
                            </div>
                            <span class="bar-number">
                                {{roundedMultiplier}}
                            </span>
                        </div>
                    </div>
                    <div *ngIf="removeMinNRows" (click)="goBackReselectDimensions()" class="wrap">
                        <button [ngClass]="{ 'btn':true, 'btn-green':true, 'btn-small':true }">Go back</button>
                        <span class="text-after-btn">and remove at least {{removeMinNRows}} columns</span>
                    </div>
                    <div *ngIf="multiplier > 2 && !removeMinNRows" (click)="goBackReselectDimensions()" class="wrap">
                        <button [ngClass]="{ 'btn':true, 'btn-gray':true, 'btn-small':true }">Go back</button>
                        <span class="text-after-btn">and swop more complex dimensions (e.g. “city”) with simpler ones (e.g. “country”), or take action below.</span>
                    </div>

                    <div *ngIf="multiplier > 1 && multiplier <= 2" (click)="goBackReselectDimensions()" class="wrap">
                        <button [ngClass]="{ 'btn':true, 'btn-gray':true, 'btn-small':true }">Go back</button>
                        <span class="text-after-btn">to re-select your dimensions from scratch</span>
                    </div>
                    <div *ngIf="multiplier > 1 && multiplier <= 2" (click)="proceedToNextPage()" class="wrap">
                        <button [ngClass]="{ 'btn':true, 'btn-green':true, 'btn-small':true }">Continue</button>
                        <span class="text-after-btn">with complexity still above target</span>
                    </div>
                    
                    <div *ngIf="multiplier < 1" (click)="proceedToNextPage()" class="wrap">
                        <button [ngClass]="{ 'btn':true, 'btn-green':true, 'btn-small':true }">Continue</button>
                    </div>
                </div>
            </div>
            <div class="table-data complexity-table">
                <table>
                    <thead>
                    <tr>
                        <th *ngFor="let col of columns" [ngClass]="{ 'eligible': col.compactImpact > 0 || col.removeImpact > 0 || col.isRemoved || col.isCompacted }">
                            {{col.name}}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="small-font">
                        <td *ngFor="let col of columns" [ngClass]="{ 'eligible': col.compactImpact > 0 || col.removeImpact > 0 || col.isRemoved || col.isCompacted }">
                            {{col.uniqueValues}} values
                        </td>
                    </tr>
                    <tr class="small-font">
                        <td *ngFor="let col of columns; let i = index" class="cell-color">
                            <div *ngIf="col.removeImpact > 0 && !col.isRemoved" class="red">
                                <a (click)="removeColumn(i)">Remove</a>: {{(-col.removeImpact)}}% <help-link helpId="28" [overrideColor]="'#ffffff'"></help-link>
                                <br>
                                <span class="font-small">
                                    &nbsp;
                                </span>
                            </div>
                            <div *ngIf="col.compactImpact > 0 && !col.isCompacted" class="yellow">
                                <a [routerLink]="['/top-vals']" [queryParams]="{projectId: projectId, dimIndex:i}">Top {{col.compactTopN}}</a>: {{(-col.compactImpact)}}% <help-link helpId="29"></help-link>
                            </div>
                            <div *ngIf="col.isRemoved" class="green">
                                Removed
                                <br>
                                <a (click)="unremoveColumn(i)" class="font-small">
                                    cancel
                                </a>
                            </div>
                            <div *ngIf="col.isCompacted && !col.isRemoved" class="green">
                                <a [routerLink]="['/top-vals']" [queryParams]="{projectId: projectId, dimIndex:i}">Top {{col.compactTopN}}</a> selected
                                <br>
                                <a (click)="removeColumnCompression(i)" class="font-small">
                                    cancel
                                </a>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</main>
